import React, { useState, useMemo, useEffect } from "react"
import {
    Box,
    FormControl,
    Select,
    MenuItem,
    ListSubheader,
    TextField,
    InputAdornment,
    Chip,
    Checkbox
} from "@mui/material"
import { KeyboardArrowDown, Search } from "@mui/icons-material"
import { sxSelect, sxMenuPaper, sxChipSelect, sxBoxRenderValue } from "./SxEventosSelectMultiple"

const Teste = (obj, searchText) => {
    const option = obj.evento.toLowerCase() + " - " + obj.descricao.toLowerCase()
    return option.indexOf(searchText.toLowerCase()) > -1
}

const EventosSelectMultiple = ({ name, options, label = "descricao", value = "id", callback, required, defaultValue, mostrarLabelTodos = false, ...rest }) => {
    const [searchText, setSearchText] = useState("")
    const displayedOptions = useMemo(
        () => options.filter((option) => Teste(option, searchText)),
        [searchText]
    )

    const [selected, setSelected] = useState([])

    useEffect(() => {
        if (defaultValue) {
            const event = {
                target: {
                    value: options.filter(evento => defaultValue.find(ev => evento.evento == ev)) || []
                }
            }
            handleChange(event)
        }
    }, [])

    const handleChange = (event) => {
        if (event.target.value.length == 0 && mostrarLabelTodos) {
            setSelected([{ [value]: "", [label]: "Todos" }])
        } else {
            let newSelected = event.target.value.filter((item) => item[value] !== "")
            setSelected(newSelected)
        }
    }

    useEffect(() => {
        callback(selected)
    }, [selected])

    return (
        <Box >
            {options &&
            <FormControl sx={{ width: '100%', color: 'black' }}>
                {/* <Typography id="search-select-label">Revenda</Typography> */}
                <Select
                    name={name}
                    multiple
                    sx={sxSelect}
                    value={selected}
                    onChange={handleChange}
                    renderValue={(selected) => (
                        <Box sx={sxBoxRenderValue} display="flex" flexWrap="wrap">
                            {selected.length == 0
                                ? (<Chip
                                    sx={sxChipSelect}
                                    key={"index"}
                                    label={"Todos"}
                                />)
                                : (
                                    selected.map((value, index) => (
                                        <Chip
                                            sx={sxChipSelect}
                                            key={index}
                                            label={value[label]}
                                        />
                                    )))
                            }
                        </Box>
                    )}
                    MenuProps={{
                        autoFocus: false,
                        PaperProps: { sx: sxMenuPaper },
                        sx: { '& .Mui-selected': { backgroundColor: '#9d56b93f' } }
                    }} // Disables auto focus on MenuItems and allows TextField to be in focus
                    inputProps={{
                        sx: { padding: '0 5px' }
                    }}
                    labelId="search-select-label"
                    IconComponent={KeyboardArrowDown}
                    id="navbar_revenda_select"
                    // onChange={(e) => setSelectedOption(e.target.value)}
                    onClose={() => setSearchText("")}
                    // This prevents rendering empty string in Select's value
                    // if search text would exclude currently selected option.
                    // renderValue={() => options.nome}
                    {...rest}
                >
                    {/* TextField is put into ListSubheader so that it doesn't
              act as a selectable item in the menu
              i.e. we can click the TextField without triggering any selection. */}
                    <ListSubheader>
                        <TextField
                            size="small"
                            // Autofocus on textfield
                            autoFocus
                            placeholder="Pesquisar..."
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                )
                            }}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                    e.stopPropagation()
                                }
                            }}
                        />
                    </ListSubheader>
                    <MenuItem key={`menu_combo_todos`} value="" onClick={() => setTimeout(() => setSelected(options), 10)}>
                            Selecionar Todos
                    </MenuItem>
                    <MenuItem key={`menu_combo_vazio`} value="" onClick={() => setTimeout(() => setSelected([]), 10)}>
                            Remover Seleção
                    </MenuItem>
                    {displayedOptions.map((option, i) => (
                        <MenuItem sx={{ height: '30px' }} key={`menu_combo_${i}`} value={option}>
                            <Checkbox checked={selected.some(element => element.evento == option.evento)} />
                            {option.evento + "-" + option[label]}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            }
        </Box>
    )
}

export default EventosSelectMultiple
